import { render } from "./InfoBox.vue?vue&type=template&id=c9d8fb66&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=c9d8fb66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d8fb66"],['__file',"src/common/components/InfoBox/InfoBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9d8fb66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9d8fb66', __exports__)) {
    api.reload('c9d8fb66', __exports__)
  }
  
  module.hot.accept("./InfoBox.vue?vue&type=template&id=c9d8fb66&scoped=true", () => {
    api.rerender('c9d8fb66', render)
  })

}


export default __exports__